import React from 'react';
import LegalPage from './LegalPage';
import privacyPolicyHtml from './privacyPolicy';
import termsOfServiceHtml from './termsOfService';

export function PrivacyPolicy() {
    return <LegalPage title="Privacy Policy" path="/privacy-policy" html={privacyPolicyHtml} />;
}

export function TermsOfService() {
    return (
        <LegalPage title="Terms and Conditions" path="/terms-of-service" html={termsOfServiceHtml} />
    );
}
